module.exports = __webpack_public_path__ + "img/team-1.edc7106b.jpg";